import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { urlJoin } from 'url-join-ts';
import settings from '../../../config/settings';
import { AppState } from '../../../store';
import styles from './LoginButton.module.scss';

export const LoginButton: React.FC = () => {
  const { t } = useTranslation();
  const currentCulture = useSelector((state: AppState) => state.cultures.currentCulture);

  return (
    <Grid item xs={12} className={styles.login}>
      <a
        href={`/initiate-login?ui_locales=${currentCulture}`}
        target='_blank'
        rel='noopener noreferrer'
        className={styles.linkText}
      >
        <img src={urlJoin(settings.staticFiles.endpoint, '/images/system/LinkArrow.svg')} className={styles.linkArrow} alt="" /> {t('login_signup.navigation.goto_to_login')}
      </a>
    </Grid>
  );
};
